import { getDocumentCategoryInfo } from "@jsq/compliance-components";
import {
  W_SERIES_LABELS,
  SELF_CERT_LABELS,
} from "~/pages/Compliance/CaseDetailsDrawer/Documents/TaxForms/utils/documentCategoryHelpers";
import { capitalizeEachWord } from "~/utils/strings";

export type DocumentMetadataValue = {
  key: string;
  value?: string | null;
};

export const formatDocumentType = (baseType: string | null | undefined): string => {
  if (!baseType) return "--";
  const info = getDocumentCategoryInfo(baseType);
  return info.title || capitalizeEachWord(baseType.replace(/_/g, " ")) || "--";
};

export const formatSubType = (value: string | null | undefined): string => {
  if (!value) return "--";

  // Check if it's a W-series or self-certification document with a predefined label
  const label = W_SERIES_LABELS[value] || SELF_CERT_LABELS[value];
  if (label) return label;

  // Otherwise use the general capitalization
  return capitalizeEachWord(value.replace(/_/g, " ")) || "--";
};

export const getMetadataValue = (
  metadata: DocumentMetadataValue[] | null | undefined,
  key: string,
): string | null => {
  if (!metadata) return null;
  return metadata.find((m) => m.key === key)?.value ?? null;
};
